// Path: ./src/utils/getShowAt.ts
import {
  CreateGfPromotionDto,
  GfFlyerItemDto,
} from "@swagger/typescript-fetch-goflyer";

/**
 * We use this enum to determine where to display the promotion, whether on gofly.ca, supermarkets, or both.
 * @param storeWebsite
 * @param goFlyerWebsite
 * @returns
 */
export function getShowAt(storeWebsite: boolean, goFlyerWebsite: boolean) {
  if (!storeWebsite && !goFlyerWebsite) {
    return CreateGfPromotionDto.ShowAtEnum.None;
  }
  if (storeWebsite && goFlyerWebsite) {
    return CreateGfPromotionDto.ShowAtEnum.Both;
  }
  if (goFlyerWebsite) {
    return CreateGfPromotionDto.ShowAtEnum.Goflyer;
  }
  if (storeWebsite) {
    return CreateGfPromotionDto.ShowAtEnum.Supermarket;
  }
}

export function setWebsite(showAt?: GfFlyerItemDto.ShowAtEnum) {
  return {
    goflyerWebsite:
      showAt === GfFlyerItemDto.ShowAtEnum.Both
        ? true
        : showAt === GfFlyerItemDto.ShowAtEnum.Goflyer
        ? true
        : false,
    storeWebsite:
      showAt === GfFlyerItemDto.ShowAtEnum.Both
        ? true
        : showAt === GfFlyerItemDto.ShowAtEnum.Supermarket
        ? true
        : false,
  };
}
